export default __webpack_public_path__ + "static/media/liquid.e5fb51aa.png";